import React from 'react'
// libs
import styled from 'styled-components'
// components
import { Paper as PaperOrigin, Scrollbar } from 'components/UI'
import { SearchWrapper as SearchWrapperOrigin } from 'components/UI/PageSearch/views'
// themes
import { colors } from 'themes'
import { SearchIconWrapper as SearchIconWrapperOrigin } from 'themes/views/layouts'
// icons
import CloseIconOrigin from '@mui/icons-material/CloseRounded'
import FilterIconOrigin from 'src/icons/filter.svg'
// utils
import { darken, size } from 'polished'

const SearchWrapper = styled(({ isFocused, ...props }) => <SearchWrapperOrigin {...props} />)<{ isFocused: boolean }>`
  align-items: center;
  background-color: ${colors.gray950};
  border-radius: 25px;
  display: flex;
  flex-direction: row-reverse;
  height: 40px;
  margin: 2px 0 2px 5px;

  div:nth-child(2) {
    color: ${colors.gray850};
    margin-left: 50px;
    margin-right: ${({ isFocused }) => (!isFocused ? 0 : '35px')};
  }
`

// @ts-ignore
const SearchIconWrapper = styled(SearchIconWrapperOrigin)`
  left: 19px;
`

const Wrapper = styled('div')<{ $isFocused: boolean }>`
  margin-top: 8px;
  transition: ${({ $isFocused }) => ($isFocused ? '0.4s' : 'none')};
  width: ${({ $isFocused }) => ($isFocused ? '632px' : '235px')};
`

const InnerWrapper = styled(PaperOrigin)`
  margin: 5px 0 0 5px;
  max-height: calc(100% - 61px);
  overflow: hidden;
  padding: 16px 0;
  position: absolute;
  width: 632px;
  z-index: 9999999;

  ${Scrollbar} {
    max-height: calc(100vh - 200px);
    padding-right: 8px;
  }
`

const CloseIcon = styled((props) => <CloseIconOrigin {...props} />)`
  cursor: pointer;
  position: absolute;
  color: white;
  right: 6px;
`

const FilterIcon = styled(FilterIconOrigin)`
  bottom: -2px;
  cursor: pointer;
  position: relative;
  right: 3px;

  path {
    fill: ${colors.blue500};
  }

  ${size('16px')};
`

const FilterWrapper = styled('div')`
  color: ${colors.blue500};
  display: flex;
  font-size: 16px;
  justify-content: flex-end;
  padding: 0 12px;
`

const IconWrapper = styled('div')`
  align-items: center;
  cursor: pointer;
  display: flex;
  height: 44px;
  justify-content: center;
  margin-top: 8px;
  width: 72px;

  &:hover {
    background-color: ${colors.purple300};
  }
`

const ShowMoreButton = styled('div')`
  color: ${colors.blue500};
  font-weight: bold;
  margin: 20px auto;
  text-align: center;
  width: 140px;

  span {
    cursor: pointer;

    &:hover {
      color: ${darken(0.1, colors.blue500)};
    }
  }
`

const SearchHelperText = styled('div')`
  color: ${colors.blue500};
  text-align: center;
`

export {
  CloseIcon,
  FilterIcon,
  FilterWrapper,
  IconWrapper,
  InnerWrapper,
  SearchHelperText,
  SearchIconWrapper,
  SearchWrapper,
  ShowMoreButton,
  Wrapper
}
